<modal-panel [title]="title" data-testid="adx-invoice-details-modal-panel" (close)="closeDialog()" >
  <ng-container data-testid="adx-invoice-details-modal-container">
    <app-adx-invoice-details [data]="data.adxInvoiceId"></app-adx-invoice-details>
  </ng-container>

  <ng-container data-testid="adx-invoice-details-modal-footer" modalPanelFooter >
    <button data-testid="adx-invoice-details-modal-close-button" mat-raised-button color="primary"
      (click)="closeDialog()">Close</button>
  </ng-container>
</modal-panel>
